// AI Insights Statuses
export const INSIGHTS_STATUS = {
  PENDING: 'pending',
  QUEUED: 'queued',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed',
  COMPLETED: 'completed'
} as const;

// AI Insights Score Keys
export const SCORE_KEY = {
  CITATIONS: 'citations',
  WEBSITE: 'website',
  GBP: 'gbp',
  REVIEWS: 'reviews',
  MAPS: 'maps',
  ORGANIC: 'organic'
} as const;

// Location Score breakdown component identifiers, from top-level indices down to leaf-level metrics
export const LOCATION_SCORE_BREAKDOWN_ITEM_ID = {
  VISIBILITY_INDEX: 'visibility_index',
  FOUNDATION_INDEX: 'foundation_index',
  GOOGLE_MAP_AND_LOCAL_PACK: 'google_map_and_local_pack',
  ORGANIC_SEARCH: 'organic_search',
  WEBSITE_AND_CONTENT: 'website_and_content',
  GBP: 'gbp',
  REVIEWS: 'reviews',
  CITATIONS: 'citations',
  CONVERSION_UX: 'conversion_ux',
  KEYWORD_COVERAGE: 'keyword_coverage',
  PAGE_OPTIMISATION: 'page_optimisation',
  TECHNICAL_HEALTH_PERFORMANCE: 'technical_health_performance',
  LOCAL_INTENT_INTERNAL_LINKING: 'local_intent_internal_linking',
  ACTIVITY_FRESHNESS: 'activity_freshness',
  CONVERSION_TRACKING: 'conversion_tracking',
  COMPLETENESS_ACCURACY: 'completeness_accuracy',
  NAP_ALIGNMENT_COMPLIANCE: 'nap_alignment_compliance',
  CATEGORY_SERVICE_ACCURACY: 'category_service_accuracy',
  VOLUME: 'volume',
  AVERAGE_RATING: 'average_rating',
  RECENCY_VELOCITY: 'recency_velocity',
  RESPONSE_RATE_QUALITY: 'response_rate_quality',
  CORE_COVERAGE: 'core_coverage',
  NAP_CONSISTENCY: 'nap_consistency',
  ADDRESS_CONSISTENCY: 'address_consistency'
} as const;

// AI Insights Recommendation Themes (shared between score breakdown items and recommendations)
export const RECOMMENDATION_THEME = {
  GBP_OPTIMIZATION: 'gbp_optimization',
  LISTINGS_VISIBILITY: 'listings_visibility',
  REVIEW_GENERATION: 'review_generation',
  CONTENT_CREATION: 'content_creation',
  BACKLINK_COVERAGE: 'backlink_coverage',
  TECHNICAL_ONSITE_IMPROVEMENTS: 'technical_onsite_improvements',
  TOPIC_FOCUS: 'topic_focus',
  PRIORITY: 'priority'
} as const;
